<template>
    <transition>
        <v-dialog-old ref="dialog" id="clinicModeration" @hidden="clearHash()" :onCloseEsc="clearHash">
            <ValidationObserver ref="modCompare">
                <mod-compare v-if="loaded"
                    :disabled="$canNot('admin.moderation.clinics.update')"
                    :o="M.old" :n="M.new" :f.sync="M.final" :p="M.info"
                    :options="modOptions" :blocks="modBlocks"
                    :main-title = "clinicTitle"
                />
            </ValidationObserver>
            <footer v-can="'admin.moderation.clinics.update'">
                <v-loading-component @click="update">
                    <template slot-scope="{ loadingClass }">
                        <button :class="['green', loadingClass]">
                            Сохранить
                        </button>
                    </template>
                </v-loading-component>
                <button class="" @click="cancel">Отменить</button>
                <label v-if="showNextCheckBox" class="float-right d-inline-block" style="display: inline-block">
                    <input type="checkbox" v-model="autoNext" @change="autoNextChange"><span>Открывать следующую</span>
                </label>
            </footer>
        </v-dialog-old>
    </transition>
</template>

<script>
import ModCompare from "@common/modCompare/ModCompare.vue"
import { modBlocks, modDefault, modOptions } from "./ClinicModerationFields";
export default {
    name: "ClinicModeration",
    components: {
        ModCompare
    },
    data: function () {
        return {
            M: {
                old: modDefault(),
                new: modDefault(),
                final: modDefault(),

                info: {
                    id: '',
                    url: '',
                    name: '',
                    city: {
                        name: '',
                        nameRus: ''
                    },
                },
            },
            modOptions: modOptions(),
            modBlocks: modBlocks,
            loaded: false,
            needWait: false,
            showNextCheckBox: true,
            autoNext: localStorage.getItem(window.location.pathname + '@autoNext') !== null && window.location.pathname.indexOf('moderation') !== -1
                ? localStorage.getItem(window.location.pathname + '@autoNext') === 'true' : false,
        }
    },
    mounted() {
        this.$bus.listen('quillInProgress', (needWait) => {
            this.needWait = needWait
        });
        window.addEventListener('beforeunload', this.clearHash);
    },
    destroyed() {
        window.removeEventListener('beforeunload', this.clearHash);
    },
    methods: {
        clearHash() {
            if (this.M.info.id) {
                this.axios.get('/admin/moderation/clinics/' + this.M.info.id + '/close');
            }

            window.location.hash = '';
        },
        update(btn) {
            btn.startLoadingAnimation();
            this.$refs.modCompare.validate().then(success => {
                if (!success) {
                    const el = document.querySelector(".hasError:first-of-type");
                    el.scrollIntoView({behavior: "smooth"});
                    btn.stopLoadingAnimation()
                    return;
                }
                this.$nextTick(() => {
                    this.$bus.fire('moderateClinics');
                });
                setTimeout( () => {
                    let delay = 2;
                    if ( this.needWait){
                        delay = 450
                    }
                    setTimeout( () => {
                        this.updateRequest(btn);
                    },delay);
                },40);
            });
        },
        updateRequest(btn) {
            this.axios.post('/admin/moderation/clinics/moderate/'+this.M.info.moderation_id,
                {fields: this.M.final}).then(data => {
                this.fireUpdatedEvent()
                btn.stopLoadingAnimation()
            });
        },
        autoNextChange: function () {
            localStorage.setItem(window.location.pathname + '@autoNext', this.autoNext);
        },
        cancel() {
            this.$modal(`Вы действительно хотите отменить изменения?`,
                {
                    name: "Отменить изменения",
                    callback: () => {
                        this.cancelRequest();
                    }
                },
                {
                    name: "Нет"
                }
            );
        },
        cancelRequest(){
            this.axios.post('/admin/moderation/clinics/cancel/' + this.M.info.moderation_id,{}).then(data => {
                this.fireUpdatedEvent()
            });
        },
        fireUpdatedEvent: function () {
            if (!this.autoNext) {
                this.$emit('updated');
            }

            this.$bus.fire('updateMenu');
            this.$refs.dialog.hide();

            if (this.autoNext) {
                this.$emit('openNext', this.M.info.id);
            }
        },
        showModal(id, showNextCheckBox = true) {
           this.showNextCheckBox = showNextCheckBox;
            return this.getData(id);
        },
        getData(id) {
            let requestPromise = this.axios.get('/admin/moderation/clinics/' + id);

            requestPromise.then(data => {
                if (data.data.error) {
                    this.$modal(data.data.error, {
                        name: 'ОК',
                        callback: () => {}
                    }, {}, false, 'only-text-dialog');
                    return;
                }
                Object.assign(this.M, data.data);
                Object.assign(this.M.final, data.data.new);
                this.modOptions.find(item => item.key === 'locality').filter.city = this.M.info.city.name
                this.modOptions.find(item => item.key === 'district').filter.city = this.M.info.city.name
                this.modOptions.find(item => item.key === 'area').filter.city = this.M.info.city.name
                this.loaded = true;
                this.$refs.dialog.show();
            });

            return requestPromise;
        }
    },
    computed: {
        clinicTitle()
        {
            return '<b>' + this.M.info.name + '</b><br/>' + this.M.info.city.nameRus + '<br/>' +
                '<a target="_blank" href="https://doctu.ru/'
                    + this.M.info.city.name
                    + '/clinic/' + this.M.info.url
                + '">'
                + this.M.info.url
                + '</a> <br/>';
        }
    },
}
</script>

<style lang="scss">
#clinicModeration {
    max-width: 79%;
}
</style>
